/*
 * Desktop search overlay.
 * Clicking the header magnifier opens a full-width panel over the header
 * (hydropool.pl style); close via the X button, Esc, or an outside click.
 */
export function searchOverlay() {
    const triggers = Array.from(document.querySelectorAll(".header__nav-search"));
    const overlay = document.querySelector(".header__search-form");

    if (!triggers.length || !overlay) {
        return;
    }

    const input = overlay.querySelector('input[type="search"]');
    const closeBtn = overlay.querySelector(".header__search-form-close");
    const inner = overlay.querySelector(".header__search-form-inner");

    const isOpen = () => overlay.classList.contains("--active");

    const open = () => {
        overlay.classList.add("--active");
        triggers.forEach((btn) => {
            btn.classList.add("--active");
            btn.setAttribute("aria-expanded", "true");
        });
        if (input) {
            // Wait a frame so the overlay is visible before focusing (fade uses visibility).
            requestAnimationFrame(() => input.focus());
        }
    };

    const close = () => {
        overlay.classList.remove("--active");
        triggers.forEach((btn) => {
            btn.classList.remove("--active");
            btn.setAttribute("aria-expanded", "false");
        });
    };

    triggers.forEach((btn) => {
        btn.addEventListener("click", (event) => {
            event.preventDefault();
            isOpen() ? close() : open();
        });
    });

    if (closeBtn) {
        closeBtn.addEventListener("click", close);
    }

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && isOpen()) {
            close();
        }
    });

    // Outside click closes (ignore clicks on the input row or the trigger).
    document.addEventListener("mousedown", (event) => {
        if (!isOpen()) {
            return;
        }
        const insideForm = inner && inner.contains(event.target);
        const onTrigger = triggers.some((btn) => btn.contains(event.target));
        if (!insideForm && !onTrigger) {
            close();
        }
    });
}
